export default [
  {
    field: 'bankruptcyCurrent',
    method: 'isEmpty',
    validWhen: false,
    message: 'A selection is required',
  },
  {
    field: 'bankruptcyCurrent',
    method: 'isLength',
    validWhen: true,
    message: 'A selection is required',
    options: [{ min: 1 }],
  },
  {
    field: 'bankruptcyFuture',
    method: 'isEmpty',
    validWhen: false,
    message: 'A selection is required',
  },
  {
    field: 'bankruptcyFuture',
    method: 'isLength',
    validWhen: true,
    message: 'A selection is required',
    options: [{ min: 1 }],
  },
];
